// removed by extract-text-webpack-plugin
module.exports = {"container":"RegularKeyboard__container__1yNoL","positionedForUsernamePassword":"RegularKeyboard__positionedForUsernamePassword__316Yy","positionedForTicketCheck":"RegularKeyboard__positionedForTicketCheck__2YFZZ","positionedForAdminLogin":"RegularKeyboard__positionedForAdminLogin__UAwzA","btnClose":"RegularKeyboard__btnClose__1eTcw","buttonBox":"RegularKeyboard__buttonBox__1F3NY","activeShift":"RegularKeyboard__activeShift__3ew0j","clearFix":"RegularKeyboard__clearFix__3Y86H","backgroundOverlay":"RegularKeyboard__backgroundOverlay__3Z1aZ"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Keyboards/RegularKeyboard/RegularKeyboard.css
// module id = 516
// module chunks = 0